<template>
  <vs-popup
    :title="'Edit notes for venue: ' + (venue ? venue.name : '')"
    @close="handlePopupClose"
    :active.sync="showThisPopup"
    class="edit-events-popup"
  >

    <div  class="p-4">
      <div v-if="clonedVenueDetails && clonedVenueDetails.dateNotes.length > 0">
        <div v-for="(dateNote, index) in clonedVenueDetails.dateNotes" :key="index" class="event-border rounded p-4 mb-2">
          <div v-if="dateNote.isEditing">
            <vs-row vs-w="12">
              <vs-col vs-w="12">
                <vs-input
                  class="inputx"
                  label="Guest message"
                  placeholder="Add message"
                  v-model="dateNote.message"
                />
              </vs-col>
            </vs-row>


            <vs-row vs-w="12" class="mt-2">
              <vs-col vs-w="12">
                <label class="vs-input--label">Date</label>
                <flat-pickr
                  :config="datePickerConfig"
                  v-model="dateNote.date"
                  placeholder="Date"
                  style="width:200px"
                  class="p-3  s-inputx vs-input--input flex"
                />
              </vs-col>
            </vs-row>
          </div>
          <div v-else>
            <p>{{dateNote.message}}</p>
            <p class="text-grey"><small>{{formattedDate(dateNote.date)}}</small></p>
          </div>

          <div class="flex mt-2">
            <vs-button
              v-if="!dateNote.isEditing"
              size="small"
              class="mr-1 whitespace-nowrap"
              @click="toggleEdit(dateNote)">
              Edit
            </vs-button>
            <vs-button
              size="small"
              type="border"
              class=" whitespace-nowrap"
              @click="deleteNote(dateNote)">
              Delete
            </vs-button>
          </div>
        </div>
      </div>
      <div v-else>
        <p>No notes for this section</p>
      </div>
      <div class="flex">
        <vs-button
          class="mt-2 whitespace-nowrap"
          type="border"
          @click="addNewNote()">
          Add new note
        </vs-button>

        <vs-button
          v-if="isDirty"
          class="ml-2 mt-2 whitespace-nowrap"
          :disabled="!isAllValid()"
          @click="handleSaveVenueClick()">
          Save
        </vs-button>
      </div>
    </div>


  </vs-popup>
</template>

<script>
import * as _ from "lodash";
import Vue from "vue";
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";
import flatPickr from "vue-flatpickr-component";
import moment from "moment";

export default {
  props: {

  },
  components: {
    flatPickr
  },
  data() {
    return {
      venue: undefined,
      clonedVenueDetails:undefined,
      showThisPopup: false,
      isDirty: false,
      datePickerConfig: {
        enableTime: false, // Set to true for time again
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: "Y-m-d", // "d-m-Y H:i" for time 2021-11-19T19:00:00Z
      },
    };
  },
  computed: {
  },
  methods: {
    async show(venue) {
      this.clonedVenueDetails = _.cloneDeep(venue);
      this.venue = venue;
      this.showThisPopup = true;
    },

    addNewNote() {
      this.clonedVenueDetails.dateNotes.push({
        "date": null,
        "message": "",
        "isEditing": true
      });
      this.isDirty = true;
    },
    toggleEdit(note) {
      Vue.set(note, "isEditing", true);
      this.isDirty = true;
    },
    async deleteNote(note) {
      var index = this.clonedVenueDetails.dateNotes.indexOf(note);
      if (index >= 0)
        this.clonedVenueDetails.dateNotes.splice(index, 1);

      this.isDirty = true;
    },
    isAllValid() {
      var res = this.clonedVenueDetails.dateNotes.every(this.isValid);
      return res;
    },
    isValid(note) {
      if (note.message.length > 1 && note.date) {
          return true;
      }
      return false;
    },
    formattedDate(date) {
      return moment(date).format('DD/MM/YYYY HH:mm');
    },
    handlePopupClose() {
      this.clonedSection = undefined;
      this.showThisPopup = false;
    },
    async handleSaveVenueClick() {
      this.$vs.loading();

      this.venue.dateNotes = this.clonedVenueDetails.dateNotes
      //Call service
      try {
        var result = await this.$store.dispatch('marcom/' + VENUE_ACTIONS.UpdateVenue, this.venue);
        this.$vs.notify({
          color: "success",
          title: "Venue updated",
          text: "Your venue was updated",
        });

        this.handlePopupClose();
      }
      catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Venue updated",
          text: "Oops, something went wrong",
        });
      }
      finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-events-popup::v-deep .vs-popup {
  width: 640px;

  .vs-popup--content {
    overflow: auto;

    .vs-tabs--content {
      max-height: calc(100vh - 225px);
      overflow: auto;
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }

  .event-border {
    background: #f8f8f8;

  }
}
</style>
